import React from "react";

const Procedures = ({processSteps}) => {
  return (
    <section id="process" className="py-5">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold mb-3 h1" style={{ color: "#c69933" }}>
            Our Seamless Treatment Journey
          </h2>
          <p
            className="text-muted mx-auto"
            style={{ maxWidth: "768px", fontSize: "1.125rem" }}
          >
            Experience our carefully crafted process designed for your comfort
            and optimal results
          </p>
        </div>

        {/* Responsive Step Cards */}
        <div className="row g-4">
          {processSteps.map((step, index) => (
            <div key={index} className="col-12 col-lg-6">
              <div className="card h-100 shadow border-0 rounded-4">
                <div className="card-body" style={{ padding: "2rem 1rem" }}>
                  {/* Icon + Title in one row */}
                  <div className="d-flex align-items-center justify-content-center justify-content-lg-start gap-3 mb-3">
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center"
                      style={{
                        width: "50px",
                        height: "50px",
                        background: "linear-gradient(135deg, #c69933, #bdaa7d)",
                        color: "white",
                        fontSize: "1.25rem",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                        flexShrink: 0,
                      }}
                    >
                      <i className={`fas ${step.icon}`}></i>
                    </div>
                    <h5 className="fw-bold text-dark mb-0">{step.title}</h5>
                  </div>

                  {/* Description below */}
                  <p className="text-muted small text-center text-lg-start mb-0">
                    {step.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Procedures;
